import { useState } from "react";
import ikas from "../../providers/ikas";
import { useNavigate } from "react-router-dom";
import { EnvelopeSimpleIcon } from "@phosphor-icons/react";

function validateEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

const ForgotPassword = ({ data }) => {
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [success, setSuccess] = useState(false);

  const onEmailChange = (e) => {
    setEmail(e.target.value);
    setError("");
  };

  const onResetClick = async () => {
    if (!validateEmail(email)) {
      setError("Geçerli bir e-posta adresi giriniz.");
      return;
    }

    setError("");
    setLoading(true);

    try {
      const response = await ikas.customerForgotPassword(email);
      console.log(response);
      setLoading(false);
      setSuccess(true);
      setToast("Şifre sıfırlama bağlantısı e-posta adresinize gönderildi!");
      setShowToast(true);
      setTimeout(() => {
        setShowToast(false);
        setTimeout(() => {
          setToast("");
          navigate("/login");
        }, 400);
      }, 3000);
    } catch (err) {
      setLoading(false);
      setError("Bir hata oluştu. Lütfen tekrar deneyin.");
    }
  };

  return (
    <div className="relative">
      {toast && (
        <div
          className={`fixed left-1/2 transform -translate-x-1/2 z-[100] w-[95vw] max-w-xl bg-[#6f59ef] text-white px-6 py-3 rounded-lg shadow-lg text-base font-semibold text-center transition-all duration-400
            ${
              showToast
                ? "opacity-100 translate-y-0"
                : "opacity-0 -translate-y-4 pointer-events-none"
            }`}
          style={{ minWidth: 320, top: data?.system?.safeArea?.top ?? 20 }}
        >
          {toast}
        </div>
      )}
      {loading && (
        <div
          className="fixed inset-0 z-50 bg-black bg-opacity-40 transition-opacity duration-200"
          style={{ pointerEvents: "none" }}
        ></div>
      )}

      <div className="m-1 mt-[10vh] flex flex-col items-center min-h-screen">
        <div
          className="w-full max-w-sm min-w-[200px] bg-white p-4 rounded-lg relative sm:max-w-md md:max-w-lg"
          style={loading ? { pointerEvents: "none" } : {}}
        >
          {!success ? (
            <>
              <div className="text-center mb-6">
                <h2 className="text-xl font-semibold text-gray-800 mb-2">
                  Şifrenizi mi unuttunuz?
                </h2>
                <p className="text-gray-600 text-sm">
                  E-posta adresinizi girin, size şifre sıfırlama bağlantısı
                  gönderelim.
                </p>
              </div>

              {/* Email Input */}
              <div className="relative">
                <EnvelopeSimpleIcon className="absolute w-5 h-5 top-3 left-2.5 text-slate-500" />
                <input
                  value={email}
                  onChange={onEmailChange}
                  type="email"
                  className="w-full pl-9 py-2 bg-transparent placeholder:text-gray-400 text-black text-base border border-gray-200 rounded-md transition duration-300 ease focus:outline-none focus:border-gray-300 hover:border-gray-300 shadow-sm focus:shadow"
                  placeholder="E-posta"
                  autoComplete="email"
                />
              </div>

              {error && (
                <div className="inline-flex mt-1 w-full">
                  <label className="cursor-pointer ml-2 text-red-500 text-md">
                    {error}
                  </label>
                </div>
              )}

              {/* Submit Button */}
              <button
                className="w-full font-bold text-sm text-white py-2.5 mt-6 rounded-lg text-center transition-colors duration-200 flex items-center justify-center"
                style={{ backgroundColor: "#6f59ef", minHeight: "42px" }}
                onClick={onResetClick}
                disabled={loading}
              >
                {loading ? (
                  <span className="flex items-center justify-center">
                    <span className="w-5 h-5 border-4 border-white border-t-transparent rounded-full animate-spin"></span>
                  </span>
                ) : (
                  "Gönder"
                )}
              </button>
            </>
          ) : (
            <div className="text-center">
              <div className="mb-6">
                <svg
                  className="w-16 h-16 text-green-500 mx-auto mb-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
                <h2 className="text-xl font-semibold text-gray-800 mb-2">
                  E-posta Gönderildi!
                </h2>
                <p className="text-gray-600 text-sm">
                  {email} adresine şifre sıfırlama bağlantısı gönderildi.
                  E-posta kutunuzu kontrol edin.
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;